"use strict";

var _createClass = function () {
  function s(e, t) {
    for (var n = 0; n < t.length; n++) {
      var s = t[n];
      s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
    }
  }

  return function (e, t, n) {
    return t && s(e.prototype, t), n && s(e, n), e;
  };
}();

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var React = require("react"),
    PropTypes = require("prop-types"),
    classnames = require("classnames"),
    CloseIcon = require("../icons/CloseIcon.js"),
    AlertBanner = function () {
  function n(e) {
    _classCallCheck(this, n);

    var t = _possibleConstructorReturn(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));

    return t.state = {
      hidden: !1
    }, t.onClose = t.onClose.bind(t), t;
  }

  return _inherits(n, React.Component), _createClass(n, [{
    key: "onClose",
    value: function value() {
      "function" == typeof this.props.onClose && this.props.onClose(), this.setState({
        hidden: !0
      });
    }
  }, {
    key: "render",
    value: function value() {
      var e = classnames("blx-alert", this.props.className, {
        "blx-hidden": this.state.hidden
      });
      return React.createElement("div", {
        style: this.props.style,
        className: e
      }, React.createElement("div", {
        className: "blx-alert-icon-container"
      }, React.createElement("span", {
        className: "blx-alert-icon-background"
      }), this.props.icon), React.createElement("div", {
        className: "blx-alert-text"
      }, React.createElement("h4", null, this.props.title), React.createElement("p", null, this.props.message)), this.props.closable && React.createElement("button", {
        className: "blx-alert-close",
        "aria-label": "close",
        onClick: this.onClose
      }, React.createElement(CloseIcon, null)));
    }
  }]), n;
}();

AlertBanner.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string,
  icon: PropTypes.node,
  message: PropTypes.string,
  closable: PropTypes.bool,
  onClose: PropTypes.func
}, AlertBanner.defaultProps = {
  className: "",
  style: null,
  title: "",
  icon: null,
  message: "",
  closable: !1,
  onClose: null
}, module.exports = AlertBanner;